import { useState } from "react";
import { useEffect } from "react";
import BidimencionalChart, {
    ITimelineChartData,
} from "../../../../../Components/apexcharts/BidimencionalChart";
import { GetAtendimentosPorPeriodo } from "../../../../../Controllers/HelpDesk/Dashboard/DashboardControllers";
import { IAtendimentoFechado } from "../../../../../Interfaces/HelpDesk/Dashboard/DashboardInterfaces";
import { ITimeSettings } from "../../../../../Tools/ProcessingTools";

interface IAtendimentosPorPeriodoChartProps {
    massaDeDados: Array<IAtendimentoFechado>;
}

export default function AtendimentosPorPeriodoChart(
    props: IAtendimentosPorPeriodoChartProps
) {
    const [dadosDoGrafico, setDadosDoGrafico] = useState<ITimelineChartData>({
        dados: [],
        datas: [],
    });

    useEffect(() => {
        if (props.massaDeDados && props.massaDeDados.length > 0) {
            const timeSet = {
                timeSlice: "w",
                inicio: Date.now() - 10 * 7 * 24 * 60 * 60 * 1000,
            } as ITimeSettings;
            setDadosDoGrafico(
                GetAtendimentosPorPeriodo(props.massaDeDados, timeSet)
            );
        }
    }, [props.massaDeDados]);

    return (
        <BidimencionalChart
            options={{
                title: {
                    text: "Atendimentos ao longo do tempo",
                },
                xaxis: {
                    type: "datetime",
                    categories: dadosDoGrafico.datas,
                },
                noData: {
                    text: "Carregando",
                },
            }}
            type="bar"
            series={[
                {
                    data: dadosDoGrafico.dados,
                },
            ]}
        />
    );
}
